module.exports = __webpack_public_path__ + "media/images/ecute/ecuteueno_en_PC-f3fdce2212a6705d3e673e4d92e25102.jpg";